// src/components/AutoAssignTypes.ts
export interface FilterGroup {
	filters: any[];
}

export interface AssignmentField {
	key: string;
	label: string;
	options: { value: string; label: string }[];
	multiple: boolean;
}

export interface AssignmentInput {
	type: 'users' | 'roles' | 'teams';
	values: { label: string; value: string }[];
}


export interface Rule {
	id: string;
	name: string;
	priority: number;
	strategy: string;
	filters: FilterGroup[];
	assignments: Record<string, AssignmentInput>;
}

export interface AutoAssignConfig {
	enabled: boolean;
	mode: 'FIRST_MATCH' | 'AGGREGATE';
	rules: Rule[];
}

export const STRATEGIES: { value: string; label: string }[] = [
	{ value: 'ROUND_ROBIN', label: 'properties.auto_assign.round_robin' },
	{ value: 'LOAD_BASED', label: 'properties.auto_assign.least_busy' },
	{ value: 'SKILL_BASED', label: 'properties.auto_assign.skill_based' },
	{ value: 'HYBRID', label: 'properties.auto_assign.hybrid' },
];

export const STRATEGY_HELPERS: Record<string, string> = {
	ROUND_ROBIN: 'properties.auto_assign.round_robin_helper',
	LOAD_BASED: 'properties.auto_assign.least_busy_helper',
	SKILL_BASED: 'properties.auto_assign.skill_based_helper',
	HYBRID: 'properties.auto_assign.hybrid_helper',
};

